import { getAdminRole } from './api';

// Mirrors backend/src/middleware/auth.js enforcement:
//  - viewer: read-only everywhere (all non-GET requests are blocked)
//  - operator: day-to-day ops (tasks, routing, runs, approvals, PM sync,
//    integration health checks) but not billing/catalog/credentials
//  - admin: everything, including tenant/billing provisioning, skill
//    registry & suite/overlay catalog governance, security review actions,
//    integration credentials, and agent profile CRUD
export function currentRole() {
  return getAdminRole();
}

export function isAdmin() {
  return currentRole() === 'admin';
}

export function isOperator() {
  return currentRole() === 'operator';
}

export function isViewer() {
  return currentRole() === 'viewer';
}

// Allowed to perform operator-tier actions (routing, approvals, runs, etc.)
export function canOperate() {
  return isAdmin() || isOperator();
}

// Allowed to perform admin-tier actions (billing, catalog, credentials).
export function canManage() {
  return isAdmin();
}

export function roleLabel() {
  const r = currentRole();
  return r ? r.charAt(0).toUpperCase() + r.slice(1) : 'Guest';
}
